var _g, _g2, _ellipse, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeloTokenTvl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 275,
    viewBox: "0 0 331 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_627)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_627",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1363 42.7423C77.2022 42.6374 77.2691 42.5331 77.337 42.4294C92.6889 18.9962 155.679 34.7897 218.028 77.705C280.377 120.619 318.476 174.404 303.127 197.838L303.13 197.84L279.304 234.208L279.146 234.111C261.408 254.411 200.431 238.286 140.054 196.728C77.9472 153.98 39.9022 100.447 54.7788 76.8695L54.7786 76.8693L54.7888 76.8537C54.8439 76.7666 54.8996 76.6799 54.9562 76.5937C55.0127 76.5074 55.0699 76.4217 55.1277 76.3364L77.1363 42.7423Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1363 42.7423C77.2022 42.6374 77.2691 42.5331 77.337 42.4294C92.6889 18.9962 155.679 34.7897 218.028 77.705C280.377 120.619 318.476 174.404 303.127 197.838L303.13 197.84L279.304 234.208L279.146 234.111C261.408 254.411 200.431 238.286 140.054 196.728C77.9472 153.98 39.9022 100.447 54.7788 76.8695L54.7786 76.8693L54.7888 76.8537C54.8439 76.7666 54.8996 76.6799 54.9562 76.5937C55.0127 76.5074 55.0699 76.4217 55.1277 76.3364L77.1363 42.7423Z",
    fill: "url(#paint0_linear_1_627)",
    fillOpacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1363 42.7423L77.9601 43.3093L77.9654 43.3012L77.9705 43.2929L77.1363 42.7423ZM218.028 77.705L218.576 76.8686L218.028 77.705ZM303.127 197.838L302.303 197.271L301.755 198.108L302.579 198.675L303.127 197.838ZM303.13 197.84L303.954 198.407L304.502 197.571L303.678 197.004L303.13 197.84ZM279.304 234.208L278.797 235.071L279.606 235.572L280.128 234.775L279.304 234.208ZM279.146 234.111L279.653 233.248L278.949 232.812L278.406 233.434L279.146 234.111ZM54.7788 76.8695L55.6118 77.4221L56.0993 76.6495L55.3859 76.077L54.7788 76.8695ZM54.7786 76.8693L53.9548 76.3023L53.4458 77.0794L54.1714 77.6618L54.7786 76.8693ZM54.7888 76.8537L55.6125 77.4207L55.6169 77.4139L55.6212 77.4071L54.7888 76.8537ZM55.1277 76.3364L55.9425 76.9168L55.947 76.9102L55.9514 76.9034L55.1277 76.3364ZM77.9705 43.2929C78.0329 43.1935 78.0964 43.0946 78.1608 42.9963L76.5133 41.8624C76.4418 41.9715 76.3714 42.0813 76.3021 42.1916L77.9705 43.2929ZM78.1608 42.9963C81.7828 37.4676 88.2798 34.1471 97.1587 33.0232C106.035 31.8996 117.167 32.9926 129.83 36.1678C155.15 42.5161 186.377 57.1331 217.48 78.5415L218.576 76.8686C187.33 55.3616 155.888 40.6242 130.286 34.2052C117.49 30.9967 106.099 29.8529 96.8986 31.0175C87.7008 32.1818 80.5671 35.6746 76.5133 41.8624L78.1608 42.9963ZM217.48 78.5415C248.583 99.9494 273.6 124.045 288.914 145.664C296.574 156.477 301.774 166.625 304.119 175.472C306.464 184.321 305.925 191.742 302.303 197.271L303.951 198.405C308.004 192.217 308.458 184.127 306.028 174.96C303.598 165.79 298.254 155.416 290.514 144.489C275.029 122.629 249.822 98.375 218.576 76.8686L217.48 78.5415ZM302.579 198.675L302.582 198.677L303.678 197.004L303.675 197.002L302.579 198.675ZM302.306 197.273L278.48 233.641L280.128 234.775L303.954 198.407L302.306 197.273ZM279.811 233.345L279.653 233.248L278.639 234.974L278.797 235.071L279.811 233.345ZM278.406 233.434C274.205 238.241 267.358 240.987 258.339 241.67C249.329 242.353 238.273 240.966 225.832 237.639C200.956 230.986 170.72 216.622 140.602 195.892L139.506 197.565C169.765 218.392 200.205 232.87 225.347 239.593C237.915 242.955 249.202 244.39 258.502 243.686C267.791 242.982 275.218 240.131 279.887 234.787L278.406 233.434ZM140.602 195.892C109.62 174.567 84.6764 150.575 69.3463 129.021C61.6789 118.24 56.4483 108.114 54.0464 99.2703C51.6434 90.4232 52.1007 82.9866 55.6118 77.4221L53.9458 76.3169C50.0186 82.541 49.6528 90.6376 52.14 99.7949C54.6283 108.956 60.0012 119.306 67.7488 130.199C83.2487 151.993 108.381 176.142 139.506 197.565L140.602 195.892ZM55.3859 76.077L55.3857 76.0768L54.1714 77.6618L54.1717 77.662L55.3859 76.077ZM55.6023 77.4363L55.6125 77.4207L53.965 76.2867L53.9548 76.3023L55.6023 77.4363ZM55.6212 77.4071C55.6734 77.3246 55.7263 77.2424 55.7799 77.1606L54.1324 76.0267C54.073 76.1175 54.0143 76.2087 53.9563 76.3003L55.6212 77.4071ZM55.7799 77.1606C55.8335 77.0789 55.8877 76.9976 55.9425 76.9168L54.3129 75.756C54.252 75.8457 54.1919 75.9359 54.1324 76.0267L55.7799 77.1606ZM55.9514 76.9034L77.9601 43.3093L76.3126 42.1753L54.3039 75.7695L55.9514 76.9034Z",
    fill: "url(#paint1_linear_1_627)",
    fillOpacity: 0.83,
    mask: "url(#path-1-inside-1_1_627)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bif_1_627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.052,
    cy: 50.7241,
    rx: 137.052,
    ry: 50.7241,
    transform: "matrix(0.823734 0.566976 -0.548004 0.836476 105.133 -3.05176e-05)",
    fill: "url(#paint2_linear_1_627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.919 197.698C299.135 203.474 292.4 206.859 283.401 207.998C274.403 209.137 263.174 208.025 250.461 204.837C225.036 198.463 193.728 183.8 162.571 162.355C131.414 140.91 106.325 116.754 90.947 95.044C83.2572 84.1882 78.0036 73.9552 75.6271 64.9873C73.2505 56.0188 73.7584 48.3471 77.5424 42.5712C81.3264 36.7953 88.0621 33.4102 97.0606 32.2712C106.058 31.1322 117.287 32.2443 130.001 35.4319C155.426 41.8067 186.734 56.4689 217.891 77.9143C249.048 99.3596 274.136 123.515 289.515 145.225C297.204 156.081 302.458 166.314 304.835 175.282C307.211 184.25 306.703 191.922 302.919 197.698Z",
    stroke: "url(#paint3_linear_1_627)",
    strokeOpacity: 0.3,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_biif_1_627)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.697,
    cy: 42.7339,
    rx: 125.697,
    ry: 42.7339,
    transform: "matrix(0.823734 0.566976 -0.548004 0.836476 112.417 11.9099)",
    fill: "url(#paint4_linear_1_627)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.875 190.049C292.701 194.894 286.811 197.585 278.807 198.252C270.805 198.919 260.731 197.559 249.259 194.349C226.316 187.93 197.834 174.128 169.259 154.46C140.683 134.791 117.441 112.991 102.962 93.6533C95.7219 83.9831 90.6817 74.9401 88.256 67.096C85.8294 59.2491 86.0302 52.6432 89.2048 47.7975C92.3794 42.9518 98.2689 40.2614 106.273 39.5942C114.275 38.9273 124.349 40.2871 135.821 43.497C158.764 49.916 187.246 63.7176 215.821 83.3863C244.397 103.055 267.639 124.855 282.118 144.193C289.358 153.863 294.398 162.906 296.824 170.75C299.251 178.597 299.05 185.203 295.875 190.049Z",
    stroke: "url(#paint5_linear_1_627)",
    strokeOpacity: 0.3,
    strokeWidth: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.368 157.641C204.802 157.228 200.157 155.564 195.508 152.368C178.258 140.443 160.948 128.61 143.59 116.678C130.727 107.836 127.644 94.2159 138.036 91.5877C143.532 90.2466 149.958 91.9386 156.777 96.6262C173.932 108.353 190.872 120.064 207.92 131.783C212.569 134.979 216.104 138.673 218.357 142.947C222.044 150.002 219.731 156.256 212.957 157.317C211.916 157.531 210.565 157.533 209.368 157.641Z",
    fill: "url(#paint6_linear_1_627)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.708 95.9647C220.621 96.585 231.108 103.885 235.22 112.481C239.332 121.076 235.5 127.477 226.53 126.949C217.665 126.429 206.93 118.821 202.761 110.318C198.753 101.73 202.69 95.3371 211.708 95.9647Z",
    fill: "url(#paint7_linear_1_627)",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_627)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1_627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9946 180.988L75.5521 170.733L83.2792 181.465L83.235 181.502C87.0924 188.797 76.3268 205.06 58.5098 218.538C40.1106 232.456 21.1588 238.133 16.18 231.218C16.1518 231.179 16.124 231.139 16.0968 231.099L8.92239 221.135L22.477 210.881C26.9014 205.167 33.0829 199.091 40.4798 193.496C47.8767 187.901 55.3629 183.637 61.9946 180.988Z",
    fill: "url(#paint8_linear_1_627)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_1_627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.7728,
    cy: 15.4286,
    rx: 41.7728,
    ry: 15.4286,
    transform: "matrix(0.797524 -0.603287 0.584305 0.811534 0 208.545)",
    fill: "#BA1956"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bi_1_627)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.6275,
    cy: 14.2669,
    rx: 38.6275,
    ry: 14.2669,
    transform: "matrix(0.797524 -0.603287 0.584305 0.811534 3.18674 207.59)",
    fill: "url(#paint9_linear_1_627)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.222 191.806C52.5757 191.881 51.9605 192.133 51.3765 192.564C50.7926 192.994 50.1272 193.687 49.3802 194.643C48.2438 196.154 47.1326 197.316 46.0466 198.131C44.9607 198.946 43.744 199.431 42.3965 199.587C41.1279 199.733 40.2357 199.508 39.7199 198.91C39.204 198.312 39.1264 197.421 39.4872 196.234L37.1744 196.502C37.1286 196.507 37.0919 196.495 37.0725 196.468C37.0531 196.441 37.0526 196.401 37.0711 196.358L37.6263 195.054C37.6448 195.01 37.6807 194.967 37.7262 194.932C37.7717 194.898 37.823 194.876 37.8689 194.87L40.2042 194.601C40.8838 193.391 41.8013 192.407 42.9568 191.649C44.0786 190.913 45.3979 190.381 46.7755 190.212C46.8088 190.209 46.8361 190.216 46.8524 190.234C46.8687 190.252 46.8729 190.279 46.8642 190.309L45.9076 192.556C45.8897 192.598 45.8553 192.641 45.8115 192.675C45.7678 192.709 45.7181 192.732 45.6727 192.739C44.8586 192.855 44.1351 193.12 43.5021 193.534C42.8264 193.975 42.3412 194.541 42.0465 195.234C41.7376 195.959 41.7163 196.472 41.9826 196.773C42.2489 197.073 42.7314 197.183 43.43 197.103C44.0838 197.028 44.6854 196.786 45.2347 196.378C45.784 195.969 46.4685 195.253 47.2881 194.228C48.4307 192.717 49.5416 191.56 50.6208 190.756C51.7 189.951 52.9147 189.471 54.2647 189.315C55.5805 189.163 56.476 189.402 56.9512 190.034C57.4264 190.665 57.4685 191.602 57.0773 192.844L59.128 192.607C59.1739 192.602 59.2106 192.614 59.23 192.641C59.2494 192.667 59.2499 192.707 59.2314 192.75L58.6762 194.055C58.6577 194.098 58.6218 194.142 58.5763 194.176C58.5308 194.21 58.4794 194.233 58.4336 194.238L56.3907 194.474C55.7297 195.721 54.8154 196.791 53.6475 197.684C52.5174 198.548 51.0942 199.19 49.5559 199.375C49.5128 199.38 49.4776 199.37 49.4572 199.346C49.4368 199.323 49.4326 199.288 49.4455 199.248L50.4035 196.997C50.4216 196.955 50.4563 196.912 50.5004 196.878C50.5446 196.844 50.5946 196.821 50.6401 196.815C51.6202 196.679 52.4189 196.359 53.0364 195.857C53.6879 195.327 54.1697 194.696 54.4816 193.963C54.8137 193.183 54.8637 192.607 54.6316 192.235C54.3995 191.863 53.9296 191.72 53.222 191.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1357 195.502L25.9164 199.45C24.9689 200.167 24.5281 201.202 24.9318 201.763C25.3354 202.324 26.4307 202.197 27.3781 201.481L32.5974 197.532C33.5448 196.816 33.9856 195.78 33.582 195.22C33.1784 194.659 32.0831 194.786 31.1357 195.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3013 193.523C31.6858 192.62 31.223 191.978 30.2677 192.088C29.3123 192.198 28.2261 193.02 27.8416 193.923C27.4571 194.826 27.9199 195.469 28.8752 195.359C29.8306 195.248 30.9168 194.427 31.3013 193.523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_627",
    x: 47.5572,
    y: 27.5833,
    width: 262.968,
    height: 219.267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bif_1_627",
    x: 67.9375,
    y: 28.5834,
    width: 241.587,
    height: 192.102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_627",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_627"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect3_foregroundBlur_1_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_biif_1_627",
    x: 36.3605,
    y: -10.8238,
    width: 312.359,
    height: 259.494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_627",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1_627",
    result: "effect3_innerShadow_1_627"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect4_foregroundBlur_1_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_627",
    x: 131.794,
    y: 90.1426,
    width: 105.074,
    height: 67.4988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_627",
    x: 4.8082,
    y: 164.718,
    width: 82.2083,
    height: 72.4446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1_627",
    x: 8.92239,
    y: 168.733,
    width: 77.0941,
    height: 65.4304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.439216 0 0 0 0 0.45098 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_1_627",
    x: -32.1918,
    y: 127.718,
    width: 149.043,
    height: 136.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bi_1_627",
    x: -29.593,
    y: 129.838,
    width: 143.845,
    height: 132.054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_627",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_627",
    x1: 18.5154,
    y1: 66.9405,
    x2: 282.033,
    y2: 274.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95D93",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0767631,
    stopColor: "#ED6184",
    stopOpacity: 0.861515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18593,
    stopColor: "#F3666F",
    stopOpacity: 0.87789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#D4497F",
    stopOpacity: 0.891443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463814,
    stopColor: "#852A4D",
    stopOpacity: 0.919572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626485,
    stopColor: "#C64174",
    stopOpacity: 0.943973
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740761,
    stopColor: "#B1285D",
    stopOpacity: 0.961114
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805272,
    stopColor: "#D36C94",
    stopOpacity: 0.970791
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891527,
    stopColor: "#A51D51",
    stopOpacity: 0.983729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_627",
    x1: 218.03,
    y1: 77.706,
    x2: 137.376,
    y2: 194.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_627",
    x1: 63.1556,
    y1: 100.651,
    x2: 249.506,
    y2: -1.30226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268924,
    stopColor: "#A72557",
    stopOpacity: 0.806788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672977,
    stopColor: "#E4C7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776209,
    stopColor: "#A72557",
    stopOpacity: 0.573934
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72557",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_627",
    x1: 218.028,
    y1: 77.7051,
    x2: 160.524,
    y2: 161.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_627",
    x1: 106.703,
    y1: 3.84084,
    x2: 151.499,
    y2: 74.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5A75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_627",
    x1: 215.958,
    y1: 83.1772,
    x2: 167.513,
    y2: 153.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_627",
    x1: 200.492,
    y1: 144.363,
    x2: 141.892,
    y2: 84.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#FFC0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555106,
    stopColor: "#EAD1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_627",
    x1: 230.647,
    y1: 121.104,
    x2: 201.777,
    y2: 93.2774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#FFC0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555106,
    stopColor: "#EAD1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_627",
    x1: 1.50004,
    y1: 249.499,
    x2: 55.4344,
    y2: 218.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95D93",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_627",
    x1: 23.8497,
    y1: -15.9358,
    x2: 68.8556,
    y2: 38.0662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74D88",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloTokenTvl);
export default __webpack_public_path__ + "static/media/velo-token-tvl.8b9642584453bbf8fa5569ae092323df.svg";
export { ForwardRef as ReactComponent };